import envs from "../envs";

export const mapaDeManuaisAssistencias = `/AreaAberta/Residencial/Manuais/mapa-manuais-assistencias.json`;
export const home = `/paravoce/residencial`;
export const cartilhaSeguro = `${envs.hostStaticCdn}/AreaAberta/Residencial/Cartilhas/Cartilha-Seguro-Residencial.pdf`;

export const mapaCondicoesGerais =
  "/AreaAberta/Residencial/CondicoesGerais/Condicoes-gerais-residencial.json";

export const areaLogada = `${envs.hostAreaLogada}/login/residencial`;
